export default function CoffeeAnimation() {
	return (
		<div className="coffee-animation-container">
			<div className="upper">
				<div className="timer"></div>
				<div className="upper-btn"></div>
			</div>
			<div className="filter">
				<div className="filter-base"></div>
				<div className="handle"></div>
				<div className="coffee"></div>
				<div className="steam"></div>
				<div className="coffee-drop"></div>
			</div>
			<div className="back">
				<div className="tray"></div>
				<div className="cup"></div>
			</div>
			<div className="lower">
				<div className="lower-btn"></div>
			</div>
		</div>
	);
}
